export default __webpack_public_path__ + "static/media/Brillenpinguin.468973f0.jpg";